var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gdpr-names" }, [
    _vm.step == _vm.STEP_CURRENT_EMPLOYEES
      ? _c(
          "div",
          [
            _c("names-list", {
              key: "ceList",
              ref: "ceList",
              attrs: {
                namesList: _vm.names.currentEmployees,
                subTitle:
                  "Input the names of your current employees so that DataMapper can find all documents where their names appear.<br>When inserting multiple, separate names by using either comma, semicolon, or new line.",
                placeHolder: "Insert current employee names",
                optionalStepText: ""
              },
              on: {
                "update:namesList": function($event) {
                  _vm.$set(_vm.names, "currentEmployees", $event)
                },
                skip: _vm.nextStep
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.step == _vm.STEP_FORMER_EMPLOYEES
      ? _c(
          "div",
          [
            _c("names-list", {
              key: "feList",
              ref: "feList",
              attrs: {
                namesList: _vm.names.formerEmployees,
                subTitle:
                  "Input the names of your former employees so that DataMapper can find all documents where their names appear.<br>When inserting multiple, separate names by using either comma, semicolon, or new line.",
                placeHolder: "Insert former employee names",
                optionalStepText:
                  "Do you want DataMapper to match with former employees?"
              },
              on: {
                "update:namesList": function($event) {
                  _vm.$set(_vm.names, "formerEmployees", $event)
                },
                skip: _vm.nextStep
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.step == _vm.STEP_CURRENT_CUSTOMERS
      ? _c(
          "div",
          [
            _c("names-list", {
              key: "ccList",
              ref: "ccList",
              attrs: {
                namesList: _vm.names.currentCustomers,
                subTitle:
                  "Input the names of your current private customers so that DataMapper can find all documents where their names appear.<br>When inserting multiple, separate names by using either comma, semicolon, or new line.",
                placeHolder: "Add names of current private customers",
                optionalStepText:
                  "Do you want DataMapper to match with current private customers?"
              },
              on: {
                "update:namesList": function($event) {
                  _vm.$set(_vm.names, "currentCustomers", $event)
                },
                skip: _vm.nextStep
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.step == _vm.STEP_FORMER_CUSTOMERS
      ? _c(
          "div",
          [
            _c("names-list", {
              key: "fcList",
              ref: "fcList",
              attrs: {
                namesList: _vm.names.formerCustomers,
                subTitle:
                  "Input the names of your former private customers so that DataMapper can find all documents where their names appear.<br>When inserting multiple, separate names by using either comma, semicolon, or new line.",
                placeHolder: "Add names of former private customers",
                optionalStepText:
                  "Do you want DataMapper to match with former private customers?"
              },
              on: {
                "update:namesList": function($event) {
                  _vm.$set(_vm.names, "formerCustomers", $event)
                },
                skip: _vm.nextStep
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "bottom-action" }, [
      _c(
        "button",
        { staticClass: "continue simple", on: { click: _vm.nextStep } },
        [_vm._v("Next")]
      ),
      _vm._v(" "),
      _vm.step > 0
        ? _c(
            "button",
            { staticClass: "back simple", on: { click: _vm.back } },
            [_vm._v("Back")]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fd2e577", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fd2e577","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./apps/account/Names.vue
// module id = 483
// module chunks = 0